import React, { Component } from 'react'
import LessonsPagination from '../../internal/LessonsPagination'
import SaveLesson from '../../internal/SaveLesson'
import templates from './templates'

import './PageBuilder.scss'

import { Wrapper, Main } from '../../styled'

import { one, two, three, four, five, six } from './img'
import history from '../../../../../history'
import { Button } from 'antd'
import { withTranslation } from 'react-i18next'
import { i18n } from '../../../../../services'
import nanoid from 'nanoid'

const templateTypes = [
  {
    title: i18n.t('pagebuilder:template1'),
    thumb: one,
    template: 'template1'
  },
  {
    title: i18n.t('pagebuilder:template2'),
    thumb: two,
    template: 'template2'
  },
  {
    title: i18n.t('pagebuilder:template3'),
    thumb: three,
    template: 'template3'
  },
  {
    title: i18n.t('pagebuilder:template4'),
    thumb: four,
    template: 'template4'
  },
  {
    title: i18n.t('pagebuilder:template5'),
    thumb: five,
    template: 'template5'
  },
  {
    title: i18n.t('pagebuilder:template6'),
    thumb: six,
    template: 'template6'
  }
]

// const templateTypesLandscape = [
//   {
//     title: i18n.t('pagebuilder:template1'),
//     thumb: oneLS,
//     template: 'template1'
//   }
// ]

class PageBuilder extends Component {
  state = {
    orientationMode: 'landscape'
  }
  addPage = template => {
    const {
      lesson: {
        pages: oldPages,
        pages_landscape: oldPagesLandscape,
      },
      lessonBuilderActions: { handleLessonInput },
      courseBuilder,
      rootPath
    } = this.props

    const pages = [...oldPages]
    const pages_landscape = [...oldPagesLandscape]


    const templateData = courseBuilder.templateData
    const backgroundImageId = templateData && templateData.background_id
    const backgroundImageLink =
      templateData &&
      templateData.background_img &&
      templateData.background_img.link
    const backgroundImageOpacity = Number(templateData && templateData.opacity)
    const backgroundColor = templateData && templateData.background_color



    console.log('Pagebuilder lesson', this.props.lesson)

    pages.push(templates()[template])
    pages_landscape.push(templates()[template])

    // Add a regular BACKGROUND_IMAGE element instead of BACKGROUND_IMAGE_AUTO

    let backgroundData = null
    if (backgroundImageLink !== null) {
      backgroundData = {
        uid: nanoid(8),
        type: 'BACKGROUND_IMAGE', // Changed from BACKGROUND_IMAGE_AUTO
        params: {
          content: backgroundImageLink,
          content_id: backgroundImageId,
          opacity: backgroundImageOpacity
        }
      }
    }

    if (backgroundColor) {
      backgroundData = {
        uid: nanoid(8),
        type: 'BACKGROUND_COLOR',
        params: {
          content: backgroundColor
        }
      }
    }

    if (backgroundData) {
      pages_landscape[pages_landscape.length - 1].data.push(backgroundData)
      pages[pages.length - 1].data.push(backgroundData)
    }

    if (pages.length > 0) {
      pages[pages.length - 1].orientation = 'portrait'
    }
    handleLessonInput('pages', pages)
    handleLessonInput('pages_landscape', pages_landscape)
    handleLessonInput('currentPage', pages.length)

    history.push(`${rootPath}/page-constructor`)
  }

  /*handleChangeSelect = (value) => {
    console.log(`selected ${value}`)
    this.setState({
      orientationMode: value
    })
  }*/

  render() {
    //const { orientationMode } = this.state

    //console.log('orientationMode: ', orientationMode)

    const {
      lessonBuilderActions: { handleLessonInput },
      rootPath,
      lesson: { pages, lessonId },
      t
    } = this.props

    console.log('Pagebuilder props', this.props)
    return (
      <Wrapper>
        <Main noPadding className="main-page-wrap">
          <div className="pb-container">
            <div className="pb-pages">
              <div className="pb-pages-list">
                <div className="pb-pages-item">
                  {pages.length > 0 ? (
                    <div>
                      <div
                        className="page page_previous"
                        onClick={() => {
                          handleLessonInput('currentPage', pages.length)
                          history.push(`${rootPath}/page-constructor`)
                        }}
                      />
                    </div>
                  ) : (
                    <div className="page page_hidden" />
                  )}
                  <div className="page page_dark page-choose-preview">
                    <div className="pb-types">
                      <div className="pb-heading">{t('select_layout')}</div>

                      <div className="pb-grid">
                        {templateTypes.map(type => (
                          <div key={type.title} className="pb-card" onClick={() => this.addPage(type.template)}>
                            <div className="pb-card-content">
                              <img className="pb-card-thumb" src={type.thumb} alt={type.title} />
                            </div>
                            <div className="pb-card-title">{type.title}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Main>

        <div className="p-footer">
          <div className="p-footer__inner p-footer__inner_justify">
            <div className="p-footer__col">
              <div className="p-footer__item">
                <LessonsPagination rootPath={rootPath} />
              </div>
            </div>
            <div className="p-footer__col">
              <div className="p-footer__item">
                <Button
                  className="rounded"
                  onClick={() =>
                    history.push(`${rootPath}/lesson-create/${lessonId}`)
                  }
                >
                  {t('buttons:back_to_lesson')}
                </Button>
              </div>
              <div className="p-footer__item">
                <SaveLesson />
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
}

export default withTranslation('pagebuilder')(PageBuilder)
